import { ApiError } from './api'

/**
 * What the shell says when signing out was refused. The server's own
 * sentence where it gave one: while the database cannot be reached, logout
 * answers 503 session_unavailable, "docsdone could not check your sign-in
 * just now. Try again in a moment.", and leaves the session and its cookie
 * live. Anything else, an answer that is not the API's or no answer at all,
 * is the sentence the terms and sign-up pages already use.
 */
export function signOutRefusal(e: unknown): string {
  if (e instanceof ApiError && e.code !== 'unknown' && e.message) return e.message
  return 'Could not sign you out.'
}

/**
 * Signs out, then `after`. A refusal goes to `refused`, with what to say, and
 * `after` does not run: the person is still signed in. The shell's Sign out
 * and the deletion page's Sign in again chained `.then(refresh)` with no
 * catch, so a refused sign-out left the page as it was and said nothing,
 * while the session stayed live (review 6, web-3).
 */
export async function signOutThen(
  logout: () => Promise<unknown>,
  after: () => void,
  refused: (sentence: string) => void,
): Promise<void> {
  try {
    await logout()
  } catch (e) {
    refused(signOutRefusal(e))
    return
  }
  after()
}
